import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { ReactNode } from 'react';
import { merge } from 'lodash';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%', // Use percentage to make it responsive
  maxWidth: 800, // Set a maximum width for larger screens
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 2,
  p: 3,
};

interface CustomModalI {
  children: ReactNode;
  open: boolean;
  handleClose?: () => void;
  styles?: object;
}

export default function CustomModal({ children, open, handleClose, styles = {} }: CustomModalI) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
    >
      <Box sx={merge(style, styles)}>
        {children}
      </Box>
    </Modal>
  );
}
